import { notFound } from 'next/navigation';
import { getRequestConfig, getTimeZone } from 'next-intl/server';

import fetchConfig from './api/fetchConfig';
 
export const locales = [
  'pl', 
  'en',
  'cz',
  'de',
  'fr',
  'ro',
  'sk',
  'it'
];
 
export default getRequestConfig(async ({locale}) => {

  if (!locales.includes(locale as any)) notFound();

  const config = await fetchConfig(locale)

  return {
    messages: config.translations,
    now: new Date()
  };

});